import { trackEvent } from "../analytics";
import { ANALYTICS } from "./analyticsEvents";

export const WEDGE_COMPLETE_KEY = "albis.wedgeCompleteTracked";
export const FIRST_EXTRACTION_KEY = "albis.firstExtractionCelebrated";
export const SHARE_PROMPT_KEY = "albis.kitaSharePromptShown";
export const SHARE_BANNER_DISMISSED_KEY = "albis.kitaShareBannerDismissed";
export const SHARE_CONTEXT_KEY = "albis.sharePromptContext";
export const SCHOOL_SETUP_CHAT_KEY = "albis.schoolSetupChatDone";
export const SHIPPED_IDEAS_DISMISSED_KEY = "albis.shippedIdeasDismissed";

/** Fire wedge_complete once per browser after first real inbox calendar tap. */
export function maybeTrackWedgeComplete() {
  try {
    if (localStorage.getItem(WEDGE_COMPLETE_KEY)) return;
    localStorage.setItem(WEDGE_COMPLETE_KEY, "1");
    trackEvent(ANALYTICS.wedge_complete);
  } catch {
    trackEvent(ANALYTICS.wedge_complete);
  }
}

export function trackSchoolCalendarTap(params) {
  trackEvent(ANALYTICS.school_calendar_tap, params);
  if (params?.source === "inbox") {
    maybeTrackWedgeComplete();
  }
}

export function trackSchoolIcsDownload(params) {
  trackEvent(ANALYTICS.school_ics_download, params);
}

export function isSharePromptShown() {
  try {
    return localStorage.getItem(SHARE_PROMPT_KEY) === "1";
  } catch {
    return false;
  }
}

/**
 * @param {{ trigger?: string, eventCount?: number|null }} [context]
 */
export function markSharePromptShown(context = {}) {
  try {
    localStorage.setItem(SHARE_PROMPT_KEY, "1");
    if (context.trigger != null || context.eventCount != null) {
      localStorage.setItem(
        SHARE_CONTEXT_KEY,
        JSON.stringify({
          trigger: context.trigger ?? null,
          eventCount: context.eventCount ?? null,
        }),
      );
    }
  } catch {
    /* ignore */
  }
}

export function getSharePromptContext() {
  try {
    const raw = localStorage.getItem(SHARE_CONTEXT_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function isShareBannerDismissed() {
  try {
    return localStorage.getItem(SHARE_BANNER_DISMISSED_KEY) === "1";
  } catch {
    return false;
  }
}

export function markShareBannerDismissed() {
  try {
    localStorage.setItem(SHARE_BANNER_DISMISSED_KEY, "1");
  } catch {
    /* ignore */
  }
}

export function shouldShowShareBanner() {
  return isSharePromptShown() && !isShareBannerDismissed();
}

export function isSchoolSetupChatDone() {
  try {
    return localStorage.getItem(SCHOOL_SETUP_CHAT_KEY) === "1";
  } catch {
    return false;
  }
}

export function markSchoolSetupChatDone() {
  try {
    localStorage.setItem(SCHOOL_SETUP_CHAT_KEY, "1");
  } catch {
    /* ignore */
  }
}

export function markFirstExtractionCelebrated() {
  try {
    localStorage.setItem(FIRST_EXTRACTION_KEY, "1");
  } catch {
    /* ignore */
  }
}

export function isFirstExtractionCelebrated() {
  try {
    return localStorage.getItem(FIRST_EXTRACTION_KEY) === "1";
  } catch {
    return false;
  }
}

export function getDismissedShippedIdeas() {
  try {
    const raw = localStorage.getItem(SHIPPED_IDEAS_DISMISSED_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function dismissShippedIdea(ideaId) {
  try {
    const ids = getDismissedShippedIdeas();
    if (!ids.includes(ideaId)) {
      localStorage.setItem(
        SHIPPED_IDEAS_DISMISSED_KEY,
        JSON.stringify([...ids, ideaId]),
      );
    }
  } catch {
    /* ignore */
  }
}
